import * as urlUtils from 'utils/Url';


// Workflows
export function getPathWorkflows(qs={}) {
  return urlUtils.appendQueryString(`/workflows`, qs);
}

export function getPathAddWorkflow() {
  return `/workflows/add`;
}

export function getPathEditWorkflow(workflowId) {
  return `/workflows/${workflowId}/edit`;
}

export function getPathReplicateWorkflow(workflowId) {
  return `/workflows/${workflowId}/replicate`;
}

export function getPathCreateWorkflowFromPlaybook(playbookId) {
  return `/workflows/${playbookId}/create-from-playbook`;
}


// Members
export function getPathWorkflowMembers(workflowId, qs={}) {
  return urlUtils.appendQueryString(`/workflows/${workflowId}/members`, qs);
}


// Logs
export function getPathWorkflowLogs(workflowId, qs={}) {
  return urlUtils.appendQueryString(`/workflows/${workflowId}/logs`, qs);
}


// Analytics
export function getPathWorkflowAnalytics(workflowId, qs={}) {
  return urlUtils.appendQueryString(`/workflows/${workflowId}/analytics`, qs);
}


// Exclusions
export function getPathWorkflowExclusions(workflowId, qs={}) {
  return urlUtils.appendQueryString(`/workflows/${workflowId}/exclusions`, qs);
}


// Conversions
export function getPathWorkflowConversions(workflowId, qs={}) {
  return urlUtils.appendQueryString(`/workflows/${workflowId}/conversions`, qs);
}


// Playbooks
export function getPathWorkflowPlaybooks(qs={}) {
  return urlUtils.appendQueryString(`/workflow-playbooks`, qs);
}
